// src/SignupPage.js
import React, { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BASE_URL;

const SignupPage = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    role: "driver", // default role
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const res = await axios.post(`${BACKEND_URL}/api/auth/signup`, formData);
      setSuccess("Account created successfully! Redirecting...");
      localStorage.setItem("token", res.data.token);

      // Redirect based on role
      if (formData.role === "admin") {
        window.location.href = "/admin";
      } else {
        window.location.href = "/driver";
      }
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.detail ||
          "Failed to sign up. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1f1f1f] text-white">
      <div className="w-full max-w-md bg-[#212121] p-8 rounded-2xl shadow-lg">
        <h1 className="text-2xl font-bold text-orange-500 mb-6 text-center">
          Create Account
        </h1>
        {error && (
          <div className="bg-red-900 text-red-300 text-sm p-3 mb-4 rounded-lg">
            {error}
          </div>
        )}
        {success && (
          <div className="bg-green-900 text-green-300 text-sm p-3 mb-4 rounded-lg">
            {success}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Username */}
          <div>
            <label className="block text-sm mb-1">Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 rounded-lg bg-[#2E2E2E] text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 rounded-lg bg-[#2E2E2E] text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm mb-1">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 rounded-lg bg-[#2E2E2E] text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          {/* Role */}
          <div>
            <label className="block text-sm mb-1">Role</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="w-full px-3 py-2 rounded-lg bg-[#2E2E2E] text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="driver">Driver</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-600 hover:bg-orange-700 text-white py-2 rounded-lg font-semibold shadow-md transition"
          >
            {loading ? "Signing up..." : "Sign Up"}
          </button>
        </form>

        <p className="mt-4 text-sm text-center text-gray-400">
          Already have an account?{" "}
          <a
            href="/login"
            className="text-orange-400 hover:text-orange-500 font-medium"
          >
            Login
          </a>
        </p>
      </div>
    </div>
  );
};

export default SignupPage;
